//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import $ from "jquery";

import donutChartTemplate from '@legacy-components/common/donut-chart/donut-chart.html';

(function() {
  const merge = function(...args) {
    const objects = [].slice.call(args, 0); // varargs...
    const extendArguments = [true, {}].concat(objects);
    return $.extend.apply(this, extendArguments);
  };

  angular.module('curalate').component('donutChart', {
    bindings: {
      chartContainerId: '@',
      data: '<',
      chartWidth: '@',
      chartHeight: '@',
      innerSize: '@',
      customOptions: '<',
      percentageValues: '<',
      showLabels: '<?',
    },
    template: donutChartTemplate,
    controller: ['$scope',
      function() {
        const self = this;
        const tooltipFormatter = function() {
          return `${this.point.name}: ${CURALATE.misc.renderToReadableNumber(null, this.point.y)}` +
                        `${self.percentageValues ? '%' : ''}`;
        };

        const buildConfigWithData = (data, showLabels) => {
          return {
            options: {
              plotOptions: {
                pie: {
                  borderWidth: 2,
                  borderRadius: 0,
                  stickyTracking: false,
                },
              },
              chart: {
                margin: [20, 20, 20, 20],
                type: 'pie',
                backgroundColor: null,
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
              },
              credits: {
                enabled: false,
              },
              tooltip: {
                formatter: tooltipFormatter,
              },
            },
            title: {
              text: ' ', // Leave this as an empty space (highcharts-ng weirdness),
                                       // use the centered div in the template file to show titles
              align: 'center',
              verticalAlign: 'middle',
              y: 6,
            },
            size: {
              width: this.chartWidth,
              height: this.chartHeight,
            },
            series: [{
              type: 'pie',
              name: '',
              innerSize: this.innerSize || '79%',
              data,
              allowPointSelect: false,
              cursor: 'pointer',
              shadow: false,
              dataLabels: {
                enabled: showLabels,
                formatter: tooltipFormatter,
              },
            }],
          };
        };

        this.$onChanges = () => {
          const config = buildConfigWithData(this.data, !!this.showLabels);
          this.config = merge(config, this.customOptions);
        };
      },
    ],
  });
})();
